<template>
    <div component="Accordion" ref="accordion" @mouseleave="collapseAll" state="edit-">
        <div class="item" block="voice" @mouseenter.stop="expand" @mouseleave="collapse" @click="open">
            <slot name="voice"></slot>
        </div>
        <div class="item" block="music" @mouseenter.stop="expand" @mouseleave="collapse" @click="open">
            <slot name="music"></slot>
        </div>
        <div class="item" block="about" @mouseenter.stop="expand" @mouseleave="collapse" @click="open">
            <slot name="about"></slot>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Container from '@/mock/Container.vue';
import AccordionItem from '@/components/Home/AccordionItem.vue';
//import Velocity from 'velocity-animate';

export default {
    name: 'Accordion',

    props: {
        landscape: {
            type: Boolean,
            required: true,
            default: true,
        },
    },

    mounted() {
        this.items = this.$refs.accordion.querySelectorAll('.item');

        if (!Array.prototype.forEach) {
            Array.prototype.forEach = function (fn, scope) {
                for (var i = 0, len = this.length; i < len; ++i) {
                    fn.call(scope, this[i], i, this);
                }
            };
        }
    },

    beforeDestroy() {},

    data() {
        return {};
    },

    methods: {
        expand(event) {
            if (this.landscape) {
                this.show(event);
                this.$emit('setFocus', event, this.landscape);
            }
        },

        open(event) {
            this.show(event);
            this.$emit('setFocus', event, this.landscape);
        },

        show(event) {
            const focus = event.currentTarget;

            focus.classList.add('expanded');
            focus.classList.remove('collapsed');
            this.getSiblings(focus).forEach(function (element) {
                element.classList.remove('expanded');
                element.classList.add('collapsed');
            });
        },

        collapse(event) {
            if (!this.landscape) return;

            this.items.forEach(function (element) {
                element.classList.remove('collapsed');
            });

            this.$emit('collapseAll', event);
        },

        collapseAll() {
            if (!this.landscape) return;

            this.items.forEach(function (element) {
                element.classList.remove('expanded');
            });
        },

        getSiblings(n) {
            return this.getChildren(n.parentNode.firstChild, n);
        },

        getChildren(n, skipMe) {
            var r = [];
            for (; n; n = n.nextSibling) if (n.nodeType == 1 && n != skipMe) r.push(n);
            return r;
        },
    },

    components: {
        Container,
        AccordionItem,
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='Accordion'] {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .radiusBig;
    overflow: hidden;
    flex-direction: column;

    @media (min-width: 980px) {
        flex-direction: row;
        height: 100%;
        overflow: visible;
    }

    > [block] {
        transition: 1s;
        // height: 100%;
    }

    &[scene='list'] {
        // min-height: 530px;

        // @media (min-width: 768px) {
        // 	min-height: auto;
        // }

        [block='voice'] {
            @media (max-width: 980px) {
                padding-top: 10px;
            }

            &.collapsed {
                @media (max-width: 767px) {
                    height: 70px !important;
                    max-height: 70px !important;
                    min-height: 70px !important;
                }
            }
        }

        [block='about'] {
            @media (max-width: 980px) {
                padding-bottom: 10px;
            }
        }

        > [block] {
            width: 100%;
            height: 33.33%;
            min-height: 80px;
            max-height: 100%;
            padding-bottom: 10px;
            padding-left: 10px;
            padding-right: 10px;

            &.expanded {
                height: calc(100% - 120px);
            }

            @media (max-height: 300px) {
                min-height: 30px;
            }

            @media (min-width: 980px) {
                width: 33.33%;
                height: 100%;
                padding-left: 15px;
                padding-bottom: 0;
                padding-right: 0;

                &:first-child {
                    padding-left: 0;
                }

                &.expanded {
                    width: 66%;
                    height: 100%;
                }

                &.collapsed {
                    height: 100%;
                    max-height: 100%;
                    min-height: 100%;
                }
            }

            &.collapsed {
                @media (max-width: 767px) {
                    height: 60px;
                    max-height: 60px;
                    min-height: 60px;

                    [block='logo'] {
                        transform: scale(0.23) translate3d(-0%, -50%, 0);
                        left: 13px;
                    }
                }
            }
        }
    }

    &[scene='detail'],
    &[scene='subpage'] {
        //.gradientHomepage;
        height: 100%;

        @media (min-width: 980px) {
            border-radius: 20px 0 0 20px;
        }

        > [block] {
            width: 100%;
            height: 100%;
            pointer-events: none;
            position: absolute;
            @media (max-width: 980px) {
                padding: 0 10px;
            }
        }
    }
}
</style>
